// extracted by mini-css-extract-plugin
export default {"optionHeader":"TextSearch_optionHeader__r7n8P","optionHeaderInFocus":"TextSearch_optionHeaderInFocus__aNz4g","optionHeaderInFocusLight":"TextSearch_optionHeaderInFocusLight__Ncg1i"};